<template>
  <v-container fluid style="overflow: hidden !important;">
   <v-layout row wrap class="hidden-sm-and-down">
     <v-flex sm8 md8 lg8 xl8 style="z-index:8;">
          <CenterSide style="z-index:8;"/>
      </v-flex>
       <v-flex sm4 md4 lg4 xl4 style=" z-index: 0;">
          <RightSide/>
      </v-flex>
      </v-layout>
      </v-container>
</template>

<script>
import CenterSide from '@/components/chat/layout/CenterSide'
import RightSide from '@/components/chat/layout/RightSide'

export default {
  data () {
    return {
      // status_login: ''
    }
  },
  components: {
    CenterSide,
    RightSide
  },
  created () {
    // this.status_login = this.$cookie.get('status_login')
  }
}
</script>
<style type="text/css" scoped>
.container{
  padding: 0px !important;
}
.fixed-content {
    min-height:100%;
    position:fixed;
    overflow-y:scroll;
    overflow-x:hidden;
}
.content {
      padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect{
    width: 100%;
    min-width: 10vw;
    height: calc(100vh - 64px);
    background-color:white;
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/layout/LayoutChat.vue